import React, { useState, useEffect } from "react";

import TagsSelectCard from "components/Tags/TagsSelectCard";

import Favorites from "./help/Favorites";
import FormData from "./help/FormData";

const Form = ({
    itemToEdit = null,
    onFormSubmit,
    onCancelHandler,
}) => {
    const [activeSection, setActiveSection] = useState('form');
    const [form, setForm] = useState({
        uid: null,
        title: "",
        favorites: [],
        tags: []
    });

    useEffect(() => {
        if (itemToEdit) {
            setForm({
                uid: itemToEdit.uid,
                title: itemToEdit.title,
                favorites: itemToEdit.favorites,
                tags: itemToEdit.tags
            });
        }
    }, [itemToEdit]);

    const handleInputChange = (e) => {
        const { name, value, type, checked } = e.target;
        setForm(prevForm => ({
            ...prevForm,
            [name]: type === "checkbox" ? checked : value,
        }));
    };

    const handleRemoveItem = (itemType, uid) => {
        switch (itemType) {
            case 'favorite':
                setForm(prev => ({
                    ...prev,
                    favorites: prev.favorites.filter(item => item.uid !== uid)
                }));
                break;
            case 'tag':
                setForm(prev => ({
                    ...prev,
                    tags: prev.tags.filter(item => item.uid !== uid)
                }));
                break;
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await onFormSubmit({
                ...form,
                favorites: form.favorites.map(item => item.uid),
                tags: form.tags.map(item => item.uid),
            });
        } catch (error) {
            console.error('Failed to save group:', error);
        }
    };

    const handleCancel = () => {
        setForm({ title: "", favorites: [], tags: [] });
        onCancelHandler();
    };

    const handleSaveSelectedItem = (itemType, selectedItems) => {
        switch (itemType) {
            case 'favorite':
                setForm(prev => ({
                    ...prev,
                    favorites: selectedItems
                }));
                break;
            case 'tag':
                setForm(prev => ({
                    ...prev,
                    tags: selectedItems
                }));
                break;
        }

        setActiveSection('form');
    };

    const renderContent = () => {
        switch (activeSection) {
            case "favorites":
                return <Favorites 
                    selectedItems={form.favorites}
                    onSave={handleSaveSelectedItem}
                    onCancel={() => setActiveSection('form')}
                />;
            case "tags":
                return <TagsSelectCard 
                    selectedItems={form.tags}
                    onSave={handleSaveSelectedItem}
                    onCancel={() => setActiveSection('form')}
                />;
            case "form":
            default:
                return <FormData
                    form={form}
                    onInputChange={handleInputChange}
                    onItemRemove={handleRemoveItem}
                    onSubmit={handleSubmit}
                    onCancel={handleCancel}
                    setActiveSection={setActiveSection}
                />;
        }
    };

    return (
       renderContent()
    );
};

export default Form;